//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class WebsiteBlockTextAndMediaImageInputItem extends ItemBase {
    WebsiteMediaLibraryItemID: string | null = null;
    Header: string | null = null;
    Body: string | null = null;
    AltText: string | null = null;
    Hyperlink: string | null = null;
    OpenInNewTab: boolean = false;
    OffsetXPercent: number = 0;
    OffsetYPercent: number = 0;
    ImageScale: number = 0;
    PlaceholderUrl: string | null = null;

    constructor(initializer?: Partial<WebsiteBlockTextAndMediaImageInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteBlockTextAndMediaImageInputItem";
}
